import script from "./ListComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListComp.vue?vue&type=script&setup=true&lang=ts"

import "./ListComp.vue?vue&type=style&index=0&id=0de68f64&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de68f64"]])

export default __exports__